import React from 'react'
import { createSlice, createAsyncThunk, nanoid } from '@reduxjs/toolkit'
import axios from 'axios'
import sub from 'date-fns/sub';

/* global process */
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const USERS_URL = `${API_BASE_URL}/api/v1/users`;
const SUPER_ADMINS_URL = `${API_BASE_URL}/api/v1/statuses/1/users/`;
const ADMINS_URL = `${API_BASE_URL}/api/v1/statuses/2/users/`;
const GENERAL_USERS_URL = `${API_BASE_URL}/api/v1/statuses/3/users/`;
const PARTICIPANTS_URL = `${API_BASE_URL}/api/v1/statuses/4/users/`;
const SPEAKERS_URL = `${API_BASE_URL}/api/v1/statuses/5/users/`;
const SPONSORS_URL = `${API_BASE_URL}/api/v1/statuses/6/users/`;
const CLIENTS_URL = `${API_BASE_URL}/api/v1/statuses/7/users/`;


const initialState = {
  users: [],
  superAdmins: [],
  admins: [],
  generalUsers: [],
  participants: [],
  speakers: [],
  sponsors: [],
  clients: [],
  is_loading: false,
  error: null,
}; /* [] */

/*
  FETCHERS
*/
export const fetchUsers = createAsyncThunk('users/fetchUsers', async() => {
  try {
    const response = await axios.get(USERS_URL);
    console.log(response.data)
    return [...response.data];
  } catch (err) {
    return err.message;
  }
})

export const fetchSuperAdmins = createAsyncThunk('users/fetchSuperadmins', async() => {
  try {
    const response = await axios.get(SUPER_ADMINS_URL);
    console.log('superAdmins', response.data);
    return [...response.data];
  } catch(err){
    return err.message
  }
})

export const fetchAdmins = createAsyncThunk('users/fetchAdmins', async() => {
  try {
    const response = await axios.get(ADMINS_URL);
    console.log(response.data)
    return [...response.data];
  } catch (err) {
    return err.message;
  }
})

export const fetchGeneralUsers = createAsyncThunk('users/fetchGeneralusers', async() => {
  try {
    const response = await axios.get(GENERAL_USERS_URL);
    console.log(response.data)
    return [...response.data];
  } catch (err) {
    return err.message;
  }
})

export const fetchParticipants = createAsyncThunk('users/fetchParticipants', async() => {
  try{
    const response = await axios.get(PARTICIPANTS_URL);
    console.log('Participants', response.data);
    return [...response.data]
  }catch(err){
    return err.message
  }
})

export const fetchSpeakers = createAsyncThunk('users/fetchSpeakers', async() => {
  try{
    const response = await axios.get(SPEAKERS_URL);
    console.log(response.data);
    return [...response.data];
  }catch(err){
    return err.message
  }
})

export const fetchSponsors = createAsyncThunk('users/fetchSponsors', async() => {
  try{
    const response = await axios.get(SPONSORS_URL);
    console.log(response.data);
    return [...response.data];
  }catch(err){
    return err.message
  }
})

export const fetchClients = createAsyncThunk('users/fetchClients', async() => {
  try{
    const response = await axios.get(CLIENTS_URL);
    console.log(response.data);
    return [...response.data];
  }catch(err){
    return err.message
  }
})

/*
  CRUD FUNCTION HERE
*/


/*
  SLICE
*/

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    userAdded: {
      reducer(state, action){
        state.push(action.payload)
      }
    },
    prepare(name, email){
      return {
        payload: {
        id: nanoid(),
        name, 
        email,
      }}
    }
  },
  extraReducers(builder) {
    builder
    //All Users
    .addCase(fetchUsers.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchUsers.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedUsers = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.users = state.users.concat(loadedUsers);
      }
    })
    .addCase(fetchUsers.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })

    //SuperAdmins
    .addCase(fetchSuperAdmins.pending, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchSuperAdmins.fulfilled, (state, action) => {
      if(typeof action.payload === 'string'){
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.action = 'succeded';

        let min = 1;
        const loadedSuperAdmins = action.payload.map((user) =>{
          //fields
          return user
        })
        state.superAdmins = state.superAdmins.concat(loadedSuperAdmins)
      }
    })
    .addCase(fetchSuperAdmins.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })

    //Admins
    .addCase(fetchAdmins.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchAdmins.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedAdmins = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.admins = state.admins.concat(loadedAdmins);
      }
    })
    .addCase(fetchAdmins.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })

    //General Users
    .addCase(fetchGeneralUsers.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchGeneralUsers.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedGeneralUsers = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.generalUsers = state.generalUsers.concat(loadedGeneralUsers);
      }
    })
    .addCase(fetchGeneralUsers.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })

    //Participants
    .addCase(fetchParticipants.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchParticipants.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedParticipants = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.participants = state.participants.concat(loadedParticipants);
      }
    })
    .addCase(fetchParticipants.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })

    //Speakers
    .addCase(fetchSpeakers.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchSpeakers.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedSpeakers = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.speakers = state.speakers.concat(loadedSpeakers);
      }
    })
    .addCase(fetchSpeakers.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })


    //Sponsors
    .addCase(fetchSponsors.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchSponsors.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedSponsors = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.sponsors = state.sponsors.concat(loadedSponsors);
        console.log(state.sponsors)
      }
    })
    .addCase(fetchSponsors.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })


    //Clients
    .addCase(fetchClients.pending, (state) => {
      state.status = 'loading'
    })
    .addCase(fetchClients.fulfilled, (state, action) => {
      if(typeof action.payload === 'string') {
        console.log(action.payload)
      }else if(typeof action.payload === 'object'){
        state.status = 'succeeded'
          //adding date and reactions
          let min = 1;
          const loadedCilents = action.payload.map(user => {
            user.created = sub(new Date(), { minutes: min++ }).toISOString();
            /* user.reactions = {
              thumbsUp: 0,
              wow: 0,
              heart: 0,
            } */
            return user;
          })
        state.clients = state.clients.concat(loadedCilents);
      }
    })
    .addCase(fetchClients.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    })
  }
})

export const selectAllUsers = (state) => state.users.users;
export const selectAllGeneralUsers = (state) => state.users.generalUsers;
export const selectAllSuperAdmins = (state) => state.users.superAdmins;
export const selectAllAdmins = (state) => state.users.admins;
export const selectAllParticipants = (state) => state.users.participants;
export const selectAllSpeakers = (state) => state.users.speakers;
export const selectAllSponsors = (state) => state.users.sponsors;
export const selectAllClients = (state) => state.users.clients;
export const selectUserById = (state, userId) =>
  state.users.users.find(user => user.id === userId);

export const { userAdded } = usersSlice.actions;

export default usersSlice.reducer
